import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';

// Minimal "new distributor" form - just the fields needed to create
// a record that's identifiable in the list view. Everything else
// (system_type, referral_rate, sub_contacts, etc.) is filled in on
// the detail page after the redirect. Matches the lead-style new
// form pattern Dave approved.

export default function DistributorNew() {
  const [company, setCompany] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [state, setState] = useState('');
  const [territory, setTerritory] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  async function onSubmit(e) {
    e.preventDefault();
    if (!company.trim() && !lastName.trim()) {
      setError('Company or contact last name is required.');
      return;
    }
    setSubmitting(true);
    setError(null);
    try {
      const res = await axios.post('/api/distributors', {
        company: company.trim(),
        first_name: firstName.trim(),
        last_name: lastName.trim(),
        province_state: state.trim(),  // contacts column (also use as fallback)
        state: state.trim(),            // distributor_details column
        country: 'USA',
        territory: territory.trim()
      });
      navigate(`/distributors/${res.data.id}`);
    } catch (err) {
      setError(err.response?.data?.error || err.message);
      setSubmitting(false);
    }
  }

  return (
    <section className="page">
      <div className="page-header">
        <div>
          <h2>New Distributor</h2>
          <div className="subtitle">
            Quick add - you'll fill in the rest on the detail page.
          </div>
        </div>
        <Link to="/distributors" className="btn-secondary btn-sm">Cancel</Link>
      </div>

      <form
        onSubmit={onSubmit}
        className="panel"
        style={{ maxWidth: 640, display: 'flex', flexDirection: 'column', gap: 'var(--space-4)' }}
      >
        <label style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-1)' }}>
          <span className="form-label">Company</span>
          <input
            type="text"
            value={company}
            onChange={(e) => setCompany(e.target.value)}
            autoFocus
            placeholder="e.g. ABC Petroleum Supply"
          />
        </label>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 'var(--space-3)' }}>
          <label style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-1)' }}>
            <span className="form-label">Primary Contact - First Name</span>
            <input
              type="text"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
            />
          </label>
          <label style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-1)' }}>
            <span className="form-label">Primary Contact - Last Name</span>
            <input
              type="text"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
            />
          </label>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 'var(--space-3)' }}>
          <label style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-1)' }}>
            <span className="form-label">State</span>
            <input
              type="text"
              value={state}
              onChange={(e) => setState(e.target.value)}
              maxLength={50}
              placeholder="e.g. CA, TX, FL"
            />
          </label>
          <label style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-1)' }}>
            <span className="form-label">Territory</span>
            <input
              type="text"
              value={territory}
              onChange={(e) => setTerritory(e.target.value)}
              placeholder="e.g. West, Southeast"
            />
          </label>
        </div>

        {error && <p className="error">{error}</p>}

        <div style={{ display: 'flex', gap: 'var(--space-2)', justifyContent: 'flex-end' }}>
          <Link to="/distributors" className="btn-secondary">Cancel</Link>
          <button type="submit" className="btn-primary" disabled={submitting}>
            {submitting ? 'Saving…' : 'Create distributor'}
          </button>
        </div>
      </form>
    </section>
  );
}
